import { render, staticRenderFns } from "./ProductService.vue?vue&type=template&id=67b081ec&scoped=true&"
import script from "./ProductService.vue?vue&type=script&lang=js&"
export * from "./ProductService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b081ec",
  null
  
)

export default component.exports